<template>
  <HScaffold title="提现管理" rightText="添加提现" :rightCallback="addWithdraw">
    <van-tabs :background="HNewGameUIConfig.newGameUIType === 3 ?'#1f1f1f':'white'" offset-top="46px" sticky v-model:active="activeName" @change="tabChange" :title-active-color="hcf.getMainColor()">
      <van-tab v-for="eachTabInfo in tabInfos" :title="eachTabInfo.name" :name="eachTabInfo.name"
               :key="eachTabInfo.name">
        <div v-if="useUser.withdrawMap[`${eachTabInfo.type}`].length>0"
             style="display: flex;flex-direction: column;padding:10px;">
          <div v-for="item in useUser.withdrawMap[`${eachTabInfo.type}`]" :key="item.BankCard"
               :style='{
                  marginBottom: "10px",
                  backgroundColor: HNewGameUIConfig.newGameUIType === 3?"#1f1f1f":"white",
                  padding: "10px",
                  borderRadius: "10px",
               }'>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <img :src="eachTabInfo.icon" style="height:20px;margin-right: 8px;" alt="">
              <div :style="hcf.getTextStyle({
            addSize:1,
          })">{{ item.BankName }}
              </div>
              <div v-if="item.RealName!==''" style="margin:0 5px">-</div>
              <div v-if="eachTabInfo.type===1||eachTabInfo.type===3||eachTabInfo.type===4" :style="hcf.getTextStyle({
            addSize:1,
          })">{{ item.RealName }}
              </div>
            </div>
            <div :style="hcf.getTextStyle({
            color:'#aaa',marginTop:3,
          })">卡号：{{ item.BankCard }}
            </div>
            <van-divider style="margin:7px;"/>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <van-checkbox @click="changeIsDefault(item,eachTabInfo.type)" :checked="item.Default" icon-size="16px"
                            style="font-size: 13px;">设为默认
              </van-checkbox>
              <div style="flex:1"/>
              <div @click="deleteWithdraw(item,eachTabInfo.type)"
                   style="display: flex;flex-direction: row;align-items: center;">
                <van-icon name="delete" style="margin-right:5px" size="18px" :color="hcf.getMainColor()"/>
                <div :style="hcf.getTextStyle({

                  })">删除
                </div>
              </div>
            </div>
          </div>
        </div>
        <EmptyDiv :title="'您还没有添加过'+eachTabInfo.name" style="margin-top: 20px;" v-if="useUser.withdrawMap[`${eachTabInfo.type}`].length<=0"/>
      </van-tab>
    </van-tabs>
    <van-action-sheet
        v-model:show="showSelectAddWithdraw"
        :actions="tabInfos"
        cancel-text="取消"
        close-on-click-action
        style="height:53%"
        @select="onSelect"
        description="选择提现方式"
    />
  </HScaffold>

</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {hr} from "@/components/utils/HRouter.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import withdraw_type_1 from "@/assets/icons/withdraw/withdraw_type_1.png";
  import withdraw_type_2 from "@/assets/icons/withdraw/withdraw_type_2.png";
  import withdraw_type_3 from "@/assets/icons/withdraw/withdraw_type_3.png";
  import withdraw_type_4 from "@/assets/icons/withdraw/withdraw_type_4.png";
  import withdraw_type_5 from "@/assets/icons/withdraw/withdraw_type_5.png";
  import withdraw_type_6 from "@/assets/icons/withdraw/withdraw_type_6.png";
  import withdraw_type_7 from "@/assets/icons/withdraw/withdraw_type_7.png";
  import withdraw_type_8 from "@/assets/icons/withdraw/withdraw_type_8.png";
  import withdraw_type_9 from "@/assets/icons/withdraw/withdraw_type_9.png";
  import withdraw_type_10 from "@/assets/icons/withdraw/withdraw_type_10.png";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {showConfirmDialog, showToast} from "vant";
  import EmptyDiv from "@/components/pages/EmptyDiv.vue";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  const useUser = useUserStore();
  const useHttp = useHHttp();
  const tabInfos = hcf.withdrawTypeList;

  const activeName = ref(hcf.getSaveActiveNameByType(hcf.saveLastActiveTabType));

  const showSelectAddWithdraw = ref(false);

  function tabChange(tabName) {
    hcf.saveLastActiveTabType = hcf.getSaveActiveTypeByName(tabName);
  }

  function changeIsDefault(e, type) {
    if (e["Default"] !== 1) {
      useHttp.request("/app/profile/modify-withdraw", (data) => {
        showToast("修改默认成功");
        useUser.withdrawMap =
            hcf.processWithDrawData(data["Data"]);
        sortWithDrawDefaultAndUpdateTick();
      }, {
        params: {
          "Id": e["Id"],
          "AppId": useUser.appId,
          "UserId": useUser.userId,
          "Type": type,
          "Default": 1,
        }
      });
    }
  }

  function sortWithDrawDefaultAndUpdateTick() {
    for (let type in useUser.withdrawMap) {
      if (useUser.withdrawMap[type] != null &&
          useUser.withdrawMap[type].length > 1) {
        useUser.withdrawMap[type].sort((a, b) => {
          if ((a["Default"] === 1) &&
              !(b["Default"] === 1)) {
            return -1;
          } else if (!(a["Default"] === 1) && b["Default"] === 1) {
            return 1;
          } else {
            return a["UpdatedTick"] - b["UpdatedTick"];
          }
        });
      }
    }
  }

  function deleteWithdraw(e, type) {
    showConfirmDialog({
      title: '确认要删除吗？',
    })
        .then(() => {
          useHttp.request(
              "/app/profile/del-withdraw",
              (resp) => {
                useUser.withdrawMap =
                    hcf
                        .processWithDrawData(
                            resp["Data"]);
                sortWithDrawDefaultAndUpdateTick();
              }, {
                params: {
                  "Id": e["Id"],
                  "AppId": useUser.appId,
                  "UserId": useUser.userId,
                  "Type": type,
                }
              });
        })
        .catch(() => {
          // on cancel
        });

  }

  function onSelect(item) {
    hr.go("add-withdraw", item);
  }

  function addWithdraw() {
    showSelectAddWithdraw.value = true;
  }

</script>


<style scoped>

  .tWithdrawMgrParentDiv {
    display: flex;
    flex-direction: column;
  }

</style>
